(function ($) {
    $.fn.resetField = function () {
        if ($(this).is('input[type="text"], input[type="password"], input[type="email"], input[type="url"], input[type="tel"], input[type="number"], input[type="search"], input[type="color"], input[type="date"], input[type="time"], input[type="datetime-local"], input[type="month"], input[type="week"], input[type="range"], input[type="hidden"]')) {
            $(this).val('');
        } else if ($(this).is('textarea')) {
            $(this).val('');
        } else if ($(this).is('input[type="checkbox"], input[type="radio"]')) {
            $(this).prop('checked', false);
        } else if ($(this).is('select')) {
            $(this).prop('selectedIndex', 0);
        } else if ($(this).is('input[type="file"]')) {
            $(this).val(null);
        }
    }
}(jQuery));

